export interface F24ValidBank {
  abi_code: string;
  name: string;
}

export const F24ValidBanksQueryKeys = {
  all: ['F24ValidBanks'] as const,
};
